export const TURN_SPEED_FAST = Math.PI * 3;
export const TURN_SPEED_SLOW = Math.PI * 1.5;
